import React from 'react';

import { cssMap, cx } from '@atlaskit/css';

import { Box } from '@atlaskit/primitives/compiled/box';

import { token } from '@atlaskit/tokens';

const styles = cssMap({
	base: {
		backgroundColor: token('elevation.surface.raised', '#FFFFFF'),
		minWidth: 'fit-content',
	},
	border: {
		borderColor: token('color.border', '#0B120E24'),
		borderStyle: 'solid',
		borderWidth: token('border.width', '1px'),
	},
	default: {
		borderRadius: token('radius.small', '4px'),
		paddingBlock: token('space.200', '16px'),
		paddingInline: token('space.200', '16px'),
	},
	compact: {
		borderRadius: token('radius.xlarge', '12px'),
		overflow: 'hidden',
	},
	compactPadding: {
		paddingBlock: token('space.150', '12px'),
		paddingInline: token('space.150', '12px'),
	},
	rowDivider: {
		borderBottomColor: token('color.border', '#0B120E24'),
		borderBottomStyle: 'solid',
		borderBottomWidth: token('border.width', '1px'),
	},
	state: {
		// Reserve room for illustrated states while allowing longer content to grow.
		minHeight: '340px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
});

/** Shared surface for recommendation cards, compact lists/rows, and placement states. */
export const RecommendationContainer = ({
	children,
	variant = 'default',
	isLast = false,
	isState = false,
	role,
	testId,
}: {
	children: React.ReactNode;
	variant?: 'default' | 'compact' | 'compact-list' | 'compact-row';
	isLast?: boolean;
	/** Reserve a consistent minimum height for loading, error, and empty states. */
	isState?: boolean;
	role?: 'status' | 'alert';
	testId?: string;
}): React.JSX.Element => (
	<Box
		xcss={cx(
			styles.base,
			variant !== 'compact-row' && styles.border,
			variant === 'default' && styles.default,
			(variant === 'compact' || variant === 'compact-list') && styles.compact,
			(variant === 'compact' || variant === 'compact-row') && styles.compactPadding,
			variant === 'compact-row' && !isLast && styles.rowDivider,
			isState && styles.state,
		)}
		role={role}
		testId={testId}
	>
		{children}
	</Box>
);
